

import Repository from "./Repository";
import _ from "lodash";

const getPath = (path) => {
    return `admin/video/${path}`;
}

//API CALL for video flow
class AdminVideoRepository extends Repository {
    //call video fetch api
    fetchVideo = async (params) => {
        try {
            const cleanParams = {};
            if (params) {
                Object.keys(params).forEach(key => {
                    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                        cleanParams[key] = params[key];
                    }
                });
            }
            const queryString = Object.keys(cleanParams).length > 0 ? new URLSearchParams(cleanParams).toString() : '';
            const path = getPath('fetchAll') + (queryString ? `?${queryString}` : '');
            const data = await this.getData(path, params);
            return _.get(data, `data`);
        } catch (error) {

            return { error };
        }
    };

    //call api for upload video 
    adminVideoUpload = async (params) => {
        try {
            const data = await this.uploadForm(getPath('upload'), params);
            return _.get(data, `data`);
        } catch (error) {
            return { error }
        }
    };


    deleteAdminVideo = async (params) => {
        try {
            const data = await this.deleteData(getPath(`delete/${params}`));
            return _.get(data, `data`);
        } catch (error) {
            return { error }
        }
    };

    checkVideoAssociation = async (videoId) => {
        try {
            const data = await this.getData(getPath(`check-association/${videoId}`));
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    updateAdminVideoTitle = async (params) => {
        try {
            const data = await this.uploadForm(getPath('update'), params);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    rearrangeContent = async (params) => {
        try {
          const data = await this.postData(`admin/courses/content/rearrange`, params);
          return _.get(data, `data`);
        } catch (error) {
          return { error };
        }
      };

    fetchCourseSubtitleList = async (params) => {
        try {
            const cleanParams = {};
            if (params) {
                Object.keys(params).forEach(key => {
                    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                        cleanParams[key] = params[key];
                    }
                });
            }
            const queryString = Object.keys(cleanParams).length > 0 ? new URLSearchParams(cleanParams).toString() : '';
            const path = 'admin/translation/courseSubtitleList' + (queryString ? `?${queryString}` : '');
            const data = await this.getData(path, {});
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    generateSubtitles = async (params) => {
        try {
            const data = await this.postData('admin/translation/generateSubtitles', params);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    fetchLanguages = async (params) => {
        try {
            const data = await this.getData('admin/translation/languages', params);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    regenerateSubtitles = async (params) => {
        try {
            const data = await this.postData('admin/translation/regenerateSubtitles', params);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };

    fetchSubtitleStatus = async (id) => {
        try {
            const videoId = typeof id === 'object' ? (id?.regeneratingVideoId || id?.id || id?.video_id) : id;
            const data = await this.getData(`admin/translation/subtitleStatus/${videoId}`);
            return _.get(data, `data`);
        } catch (error) {
            return { error };
        }
    };
}

export default new AdminVideoRepository("video");
